export const config = {
  apiKey: "AIzaSyA4IN9CoeA7c39xkjTZiTuC6TsYIaMT_Ek",
  authDomain: "msrweb-android.firebaseapp.com",
  projectId: "msrweb-android",
  storageBucket: "msrweb-android.appspot.com",
  messagingSenderId: "499593460923",
  appId: "1:499593460923:web:d1dd3b7f21d02d9fe8bd9e",
  measurementId: "G-ZQRY4KYQ00",
};
